import Vue from 'vue'
import Vuex from 'vuex'

import { PAGE_TITLE, PROGRESS_START, PROGRESS_FINISH, PROGRESS_FAIL } from './mutation-types';
import auth from './modules/auth';
import stockistDetail from './modules/stockist/detail';
import transaksi from './modules/stockist/transaksi';
import transactionPayment from './modules/transaction/pembayaran';
import transaction from './modules/dev2/public/transaksi';
import transactionMember from './modules/dev2/member/transaksi';
import product from './modules/dev2/public/product';
import stockist from './modules/dev2/public/stockist';
import cart from './modules/dev2/public/cart';
import bank from './modules/dev2/public/bank';
import bankMember from './modules/dev2/member/bank';
import address from './modules/dev2/public/address';
import listProduct from './modules/dev2/public/listProduct';
import registration from './modules/dev2/public/registration';
import maps from './modules/dev2/public/maps';

Vue.use(Vuex)

const state = {
    pageTitle: 'Mobile Counter Milagros',
    progressStatus: '',
};

const getters = {

};

const mutations = {
    [PAGE_TITLE](state, title) {
        state.pageTitle = title;
    },

    [PROGRESS_START](state) {
        state.progressStatus = 'start';
    },

    [PROGRESS_FINISH](state) {
        state.progressStatus = 'finish';
    },

    [PROGRESS_FAIL](state) {
        state.progressStatus = 'fail';
    },
};

const actions = {
    setPageTitle({ commit }, title) {
        commit(PAGE_TITLE, title);
    },
};

export default new Vuex.Store({
    state,
    getters,
    mutations,
    actions,
    modules: {
        auth,
        stockistDetail,
        transaksi,
        transactionPayment,
        transaction,
        transactionMember,
        product,
        stockist,
        cart,
        bank,
        address,
        listProduct,
        registration,
        maps,
        bankMember
    },
});